<template>
    <div>
        <Dialog
            :header="$t('Image upload')"
            v-model:visible="displayModal"
            :breakpoints="{'960px': '75vw', '640px': '90vw'}"
            :style="{width: '50vw'}"
            :modal="true">

        <div v-if="imageType == 'profile'">
            <vue-cropper
                class="m-0"
                ref="cropper"
                :src="imageSrc"
                alt="Source Image"
                :aspectRatio="1/1"
                :zoomable="false"
                :autoCropArea="1.0"
                >
            </vue-cropper>
        </div>
        <div v-if="imageType == 'banner'">
            <vue-cropper
                class="m-0"
                ref="cropper"
                :src="imageSrc"
                alt="Source Image"
                :aspectRatio="3/1"
                :zoomable="false"
                :autoCropArea="1.0"
                >
            </vue-cropper>
        </div>
            <template #footer>
                <Button :label="$t('Cancel')" icon="pi pi-times" @click="closeModal" class="p-button-text" />
                <Button :label="$t('Upload')" icon="pi pi-check" @click="onClickImageUpload" autofocus />
            </template>
        </Dialog>

        <div class="profile_head">
            <div class="banner_image" v-if="bannerImage">
                <img :src="bannerImage" alt="banner_image" />
            </div>

            <div class="profile_image" v-if="profileImage">
                <img :src="profileImage" alt="profile_image" />
            </div>
        </div>

        <FileUpload
            class="profile_image_button"
            :chooseLabel="$t('Profile image')"
            mode="basic"
            name="image"
            accept="image/*"
            :maxFileSize="10485760"
            :customUpload="true"
            @uploader="onClickProfileModalShow"
            :auto="true" />

        <FileUpload
            class="banner_image_button"
            :chooseLabel="$t('Banner image')"
            mode="basic"
            name="image"
            accept="image/*"
            :maxFileSize="10485760"
            :customUpload="true"
            @uploader="onClickBannerModalShow"
            :auto="true" />

        <span class="p-float-label input-item">
            <InputText id="name" type="text" v-model="formData.name"/>
            <label for="name">Name</label>
        </span>

        <span class="p-float-label input-item">
            <InputText id="uid" type="text" v-model="formData.uid"/>
            <label for="uid">UID</label>
        </span>

        <span class="p-float-label input-item">
            <InputText id="email" type="text" v-model="formData.email"/>
            <label for="email">Email</label>
        </span>

        <span class="p-float-label input-item">
            <Textarea id="profile" v-model="formData.profile" :autoResize="true" rows="5" cols="30" />
            <label for="profile">Profile</label>
        </span>

        <span class="p-float-label input-item">
            <InputText id="social_twitter" v-model="formData.social_twitter" />
            <label for="social_twitter">Twitter</label>
        </span>
        <span class="p-float-label input-item">
            <InputText id="social_instagram" v-model="formData.social_instagram" />
            <label for="social_instagram">Instagram</label>
        </span>
        <span class="p-float-label input-item">
            <InputText id="social_facebook" v-model="formData.social_facebook" />
            <label for="social_facebook">Facebook</label>
        </span>

        <Button
            type="button"
            :label="$t('Update')"
            class="p-button-rounded"
            @click="onClickUpdate"
            />
    </div>
</template>

<script>
import {
    ref,
    onMounted,
    reactive,
    computed,
} from 'vue';
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { errorToast } from './../../itemListError.js';
import { useToast } from "primevue/usetoast";
import axios from "axios";
import FileUpload from 'primevue/fileupload';
import Dialog from 'primevue/dialog';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import Textarea from 'primevue/textarea';

export default {
    components: {
        Button,
        InputText,
        FileUpload,
        Dialog,
        VueCropper,
        Textarea,
    },
    setup(props) {
        const toast = useToast();

        const formData = reactive({
            name: "",
            email: "",
            profile: "",
            uid: "",
            social_instagram: "",
            social_facebook: "",
            social_twitter: "",

        })

        const bannerImage = ref("")
        const profileImage = ref("")

        const load = () => {
            const user = JSON.parse(document.getElementById("json-data-user").textContent)
            formData.name = user.name;
            formData.email = user.email;
            formData.uid = user.uid;
            formData.profile = user.profile;
            formData.social_instagram = user.social_instagram;
            formData.social_facebook = user.social_facebook;
            formData.social_twitter = user.social_twitter;

            profileImage.value = user.profile_image_path;
            bannerImage.value = user.banner_image_path;
        }
        onMounted(load);

        const onClickUpdate = function() {
            const postData = {
                uid: formData.uid,
                name: formData.name,
                tentative_email: formData.email,
                profile: formData.profile,
                social_instagram: formData.social_instagram,
                social_facebook: formData.social_facebook,
                social_twitter: formData.social_twitter,

            }
            axios.post(
                '/api/my',
                postData,
            ).then(res => {
                location.href = '/my';
            }).catch(error => {
                errorToast(error.response.data, toast);
            })
        }


        const imageSrc = ref("")
        const imageType = ref("profile")

        const initImageModal = () => {
            displayModal.value = true
        }

        const onClickBannerModalShow = function(event)
        {
            imageType.value = "banner"
            imageSrc.value = event.files[0].objectURL
            initImageModal()
        }

        const onClickProfileModalShow = function(event)
        {
            imageType.value = "profile"
            imageSrc.value = event.files[0].objectURL
            initImageModal()
        }

        const onClickImageUpload = function() {
            cropper.value.getCroppedCanvas().toBlob((blob) => {
                const postData = new FormData()
                postData.append('file', blob)
                postData.append('type', imageType.value)

                axios.post(
                    '/api/my/image_upload',
                    postData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                ).then(res => {
                    toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
                    profileImage.value = res.data.data.profile_image_path;
                    bannerImage.value = res.data.data.banner_image_path;
                    displayModal.value = false;
                }).catch(error => {
                    errorToast(error.response.data, toast);

                })

            })
            //const postData = {
            //    file: cropper.value.getCroppedCanvas().toDataURL()
            //}

        }

        const displayModal = ref(false);

        const openModal = () => {
            displayModal.value = true;
        };

        const cropper = ref();

        const closeModal = () => {
            displayModal.value = false;
        };

        const crop = (e) => {
            console.log(e)
        }

        return {
            formData,
            onClickUpdate,
            onClickProfileModalShow,
            onClickBannerModalShow,
            onClickImageUpload,
            openModal,
            displayModal,
            closeModal,
            crop,
            cropper,
            profileImage,
            bannerImage,
            imageSrc,
            imageType,
        }
    },
}
</script>

